import { useRef, useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import Fade from 'react-reveal/Fade';

function Hero() {
    const colors = [{
        dark: '#282828',
        darkrgb: '40, 40, 40',
        light: '#F5F5F5',
        lightrgb: '245, 245, 245',
        accent: '#ffffff',
        accentrgb: '255, 255, 255'
    }];
  
    const [count, setCount] = useState(0);
    const increment = () => {
      setCount(count + 1);
    }

    const systemPrefersDark = useMediaQuery(
        {query: '(prefers-color-scheme: dark)'}, undefined);
  
    const [darkTheme, setDarkTheme] = useState(systemPrefersDark);
    useEffect(() => {
        updateColors();
    }, [darkTheme]);
  
    const updateColors = () => {
      const root = document.documentElement;
      root?.style.setProperty("--background-color", darkTheme ? colors[index].dark : colors[index].light);
      root?.style.setProperty("--background-color-rgb", darkTheme ? colors[index].darkrgb : colors[index].lightrgb);
      root?.style.setProperty("--text-color", darkTheme ? colors[index].light : colors[index].dark);
      root?.style.setProperty("--text-color-rgb", darkTheme ? colors[index].lightrgb : colors[index].darkrgb);
      root?.style.setProperty("--accent-color", colors[index].accent);
      root?.style.setProperty("--accent-color-rgb", colors[index].accentrgb);
      increment();
    };
  
    const [index] = useState(0);
    useEffect(() => {
      updateColors();
    }, [index]);

    const name = useRef();
    useEffect(() => {
        document.addEventListener('scroll', scrollEvent);
    }, []);
    const scrollEvent = e => {
        let scroll = 1 - window.scrollY / window.innerHeight;
        scroll = Math.max(scroll, 0);
        let max = window.innerWidth > 1000 ? window.innerWidth * 0.11 : 80;
        scroll = (max - 36) * scroll + 36;
        scroll = Math.round(scroll * 10) / 10;
        name.current.style.fontSize = "" + scroll + "px";
    }

    return (
        <div className="Hero">
            <a className="name link" href="#" ref={name}>
                <Fade top><div>Jacob Yoon</div></Fade>
            </a>
            <h1 className="name hidden">
                <Fade top><div>Jacob Yoon</div></Fade>
            </h1>
            <div className="center">
                <p>
                    <Fade top><div>Developer, designer, and artist studying computer science at Rochester Institute of Technology.</div></Fade>
                </p>
                <Fade top><a href="#about" className="button">
                    <span className="textouter">
                        <span className="text" data-text="About me">About me</span>
                    </span>
                </a></Fade>
            </div>
            <h1 className="bottom">
                <Fade top><div>Personal Website</div></Fade>
            </h1>

            <input type="checkbox" id="chk" className="checkbox" onChange={() => setDarkTheme(!darkTheme)} />
            
            <Fade top>
                <label htmlFor="chk" className="label">
                    <p className="dark">Dark</p>
                    <p className="light">Light</p>
                    <div className="ball"></div>
                </label>
            </Fade>
        </div>
    );
}

export default Hero;
